import { StockService } from '../services/stockService';

// Debug watchlist to understand why recommendations aren't generating
export const debugWatchlist = async () => {
  console.log('=== Debugging Watchlist for Recommendations ===');
  
  try {
    const watchlist = await StockService.getWatchlist();
    
    console.log(`\nTotal stocks in watchlist: ${watchlist.length}`);
    
    // Group by different criteria
    const hasPivot = watchlist.filter(w => w.pivotPrice);
    const hasDistance = watchlist.filter(w => w.distanceFromPivot !== null && w.distanceFromPivot !== undefined);
    const hasVolume = watchlist.filter(w => w.volumeChgVs50Day !== undefined);
    
    console.log(`\nData completeness:`);
    console.log(`- Has pivot price: ${hasPivot.length}`);
    console.log(`- Has distance calculated: ${hasDistance.length}`);
    console.log(`- Has volume data: ${hasVolume.length}`);
    
    // Check candidates that might qualify
    const nearPivot = hasDistance.filter(w => Math.abs(w.distanceFromPivot!) <= 3);
    const goodVolume = hasVolume.filter(w => w.volumeChgVs50Day! >= 50);
    const hasAllData = watchlist.filter(w => 
      w.pivotPrice && 
      w.distanceFromPivot !== null && 
      w.distanceFromPivot !== undefined
    );
    
    console.log(`\nPotential candidates:`);
    console.log(`- Within 3% of pivot: ${nearPivot.length}`);
    console.log(`- Volume >= 50%: ${goodVolume.length}`);
    console.log(`- Has complete data: ${hasAllData.length}`);
    
    // Show specific examples
    console.log(`\nStocks near pivot (within 3%):`);
    nearPivot.slice(0, 5).forEach(w => {
      console.log(`- ${w.symbol}:`);
      console.log(`  Current: $${w.currentPrice.toFixed(2)}`);
      console.log(`  Pivot: $${w.pivotPrice?.toFixed(2)}`);
      console.log(`  Distance: ${w.distanceFromPivot?.toFixed(2)}%`);
      console.log(`  Volume: ${w.volumeChgVs50Day !== undefined ? w.volumeChgVs50Day.toFixed(0) + '%' : 'N/A'}`);
    });
    
    // Check for common issues
    console.log(`\nChecking for common issues:`);
    
    const noPivotCount = watchlist.filter(w => !w.pivotPrice).length;
    if (noPivotCount > 0) {
      console.log(`⚠️  ${noPivotCount} stocks have no pivot price set`);
    }
    
    const noDistanceButHasPivot = watchlist.filter(w => 
      w.pivotPrice && (w.distanceFromPivot === null || w.distanceFromPivot === undefined)
    );
    if (noDistanceButHasPivot.length > 0) {
      console.log(`⚠️  ${noDistanceButHasPivot.length} stocks have pivot but no distance calculated`);
      noDistanceButHasPivot.slice(0, 3).forEach(w => {
        console.log(`   - ${w.symbol}: Pivot=${w.pivotPrice}, Current=${w.currentPrice}`);
      });
    }
    
    // Manual distance calculation check
    console.log(`\nManual distance calculation check:`);
    hasAllData.slice(0, 3).forEach(w => {
      const manualDistance = ((w.currentPrice - w.pivotPrice!) / w.pivotPrice!) * 100;
      console.log(`- ${w.symbol}:`);
      console.log(`  Stored distance: ${w.distanceFromPivot?.toFixed(2)}%`);
      console.log(`  Manual calculation: ${manualDistance.toFixed(2)}%`);
      console.log(`  Match: ${Math.abs(manualDistance - w.distanceFromPivot!) < 0.01 ? 'YES' : 'NO'}`);
    });
    
    return {
      total: watchlist.length,
      withPivot: hasPivot.length,
      nearPivot: nearPivot.length,
      goodVolume: goodVolume.length,
      qualifiedCandidates: nearPivot.filter(w => 
        w.volumeChgVs50Day === undefined || w.volumeChgVs50Day >= 50
      ).length
    };
    
  } catch (error) {
    console.error('Error debugging watchlist:', error);
    throw error;
  }
};

// Make it available on window for console testing
if (typeof window !== 'undefined') {
  (window as any).debugWatchlist = debugWatchlist;
}